import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
})
export class PermissionComponent implements OnInit {

  public permission = null;
  constructor() {
    this.permission = JSON.parse(decodeURIComponent(localStorage.getItem('role')));
  }

  ngOnInit(): void {
  }

  public isMenuAllowed(menu: string): boolean {
    let result = true;
    if(this.permission != null){
      if(menu in this.permission){
        return this.permission[menu];
      }
    }
    return  result;
  }
}
